import React from 'react';

export const BCTextInput = ({ onChange, value, label, disabled = true, id, name, type }) => (
  <div className="BCTextInput__container">
    <label className="BCTextInput__label">{label}</label>

    <input
      className="BCTextInput__input"
      placeholder={label}
      onChange={onChange}
      value={value ?? ''}
      disabled={disabled}
      id={id ?? ''}
      name={name ?? ''}
      type={type ?? 'text'}
    ></input>
  </div>
);
